export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  'pages_read_engagement',
];

// KAVANAH patch 1: upstream #14695 still adds these two deprecated scopes
// back on Reauthorize for any Messenger inbox with an instagram_id. Meta v25
// rejects them ("Invalid Scopes") and our app holds neither, so keep every
// Messenger FB.login on the 5-scope set. IG DMs use the Instagram channel.
export const INSTAGRAM_SCOPES = [];

export const buildFacebookLoginScopes = ({
  includeInstagramScopes = false,
} = {}) => {
  const scopes = [...FACEBOOK_PAGE_SCOPES];
  if (includeInstagramScopes) {
    scopes.push(...INSTAGRAM_SCOPES);
  }
  return scopes.join(',');
};
